module.exports = __webpack_public_path__ + "img/zurueck_handschrift_01.9fc6f4cd.png";